import { render, staticRenderFns } from "./pen-popup.vue?vue&type=template&id=a6e8a9c6&"
import script from "./pen-popup.vue?vue&type=script&lang=js&"
export * from "./pen-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports